import axios from "axios";
import { Employee } from "../../model/user";

export const doEmployeeFetchApiCall = ({
  companyId,
  id,
}: {
  companyId: number;
  id: number;
}) => {
  return axios.get<Employee>(`/api/companies/${companyId}/employees/${id}`);
};

export const doEmployeesFetchApiCall = ({
  companyId,
  params,
}: {
  companyId: number;
  params?: { q?: string; departmentId?: number; onlyHeadOfDepts?: number };
}) => {
  return axios.get<Employee[]>(`/api/companies/${companyId}/employees`, {
    params,
  });
};

export const doEmployeeCreationApiCall = ({
  companyId,
  data,
}: {
  companyId: number;
  data: { name: string; departmentId?: number; email: string };
}) => {
  return axios.post<Employee>(`/api/companies/${companyId}/employees`, data);
};

export const doEmployeeEditionApiCall = ({
  companyId,
  employeeId,
  data,
}: {
  companyId: number;
  employeeId: number;
  data: { name?: string; companyRole?: string; departmentId?: number };
}) => {
  return axios.put<Employee>(
    `/api/companies/${companyId}/employees/${employeeId}`,
    data
  );
};
